(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionDialogController', Qsched_directionDialogController);

    Qsched_directionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Qsched_direction'];

    function Qsched_directionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Qsched_direction) {
        var vm = this;

        vm.qsched_direction = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.qsched_direction.id !== null) {
                Qsched_direction.update(vm.qsched_direction, onSaveSuccess, onSaveError);
            } else {
                Qsched_direction.save(vm.qsched_direction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:qsched_directionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
